// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ov-5";
export var filledCircle = "_ov-4";
export var historyEntry = "_ov-3";
export var messageSideLeft = "_ov-1";
export var messageSideRight = "_ov-2";
export var orderTrackingCarouselWrapper = "_ov-6";
export var orderTrackingInfoContainer = "_ov-0";